export const createWindchillLink = (url = '', ruleId = '', parser = '{ruleId}') => {
  if (typeof ruleId !== 'string') throw new Error('Wrong ruleID provided')
  return url.replace(parser, ruleId.replace(/\D/g, '') || '') // \D is the regex for not digit, the same as [^0-9]
}

export const createWindchillLinkExplanationsPAC = (url = '', ruleId = '', parser = '{ruleId}') => {
  if (typeof ruleId !== 'string') throw new Error('Wrong ruleID provided')

  const match = ruleId.match(
    /(com\.ptc\.windchill\.option\.model\.(?:ExpressionAlias|ChoiceRule))\.(\d+)/
  )

  if (!match) {
    throw new Error('Invalid ruleId format')
  }

  return url.replace(parser, `${ match[1] }%3A${ match[2] }`)
}
